var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 81,
    fill: "#EB6502"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 29C17 25.6863 19.6863 23 23 23H59C62.3137 23 65 25.6863 65 29V53C65 56.3137 62.3137 59 59 59H23C19.6863 59 17 56.3137 17 53V29ZM23 26C21.3431 26 20 27.3431 20 29V29.6507L41 42.2507L62 29.6507V29C62 27.3431 60.6569 26 59 26H23ZM62 33.1493L47.8758 41.6238L62 50.3157V33.1493ZM61.8987 53.7759L44.9775 43.3628L41 45.7493L37.0225 43.3628L20.1013 53.7759C20.4432 55.0566 21.6115 56 23 56H59C60.3885 56 61.5568 55.0566 61.8987 53.7759ZM20 50.3157L34.1242 41.6238L20 33.1493V50.3157Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mailIcon.2869dac44fd6ff229e405c0d8eb39fd8.svg";
export { ForwardRef as ReactComponent };